/* eslint-disable */
// Back to top button
$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    $('.back-to-top').fadeIn('slow');
  } else {
    $('.back-to-top').fadeOut('slow');
  }
});

$(function () {
  //Counters
  if ($(".counter-item [data-to]").length > 0) {
    $(".counter-item [data-to]").each(function () {
      var stat_item = $(this),
        offset = stat_item.offset().top;
      if ($(window).scrollTop() > (offset - 800) && !(stat_item.hasClass('counting'))) {
        stat_item.addClass('counting');
        stat_item.countTo();
      };
      $(window).scroll(function () {
        if ($(window).scrollTop() > (offset - 800) && !(stat_item.hasClass('counting'))) {
          stat_item.addClass('counting');
          stat_item.countTo();
        }
      });
    });
  };
}());



// WEBPACK FOOTER //
// ./src/assets/js/script.js